module.exports = {"632803100":"花土沟镇","632803101":"茫崖镇","632803102":"冷湖镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632803.json
// module id = 3019
// module chunks = 0